import padDigits from './pad-digits';
export default padDigits(0);
